import React, { useState, useEffect } from "react";
import { Outlet, NavLink } from "react-router-dom";
import { data } from "../data/value";
import { HiCalendar, HiHome } from "react-icons/hi";
import { SiCashapp } from "react-icons/si";
import { CiSettings } from "react-icons/ci";
import { RxCross2 } from "react-icons/rx";
/* import Header from "./Header"; */

const Layout = () => {
  const [logo, setLogo] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("uploadedLogo");
    if (stored) {
      setLogo(JSON.parse(stored));
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "auto";
  }, [sidebarOpen]);

  return (
    <div className="flex h-screen overflow-auto relative">
      {/* Sidebar */}
      <aside
        className={`fixed md:static top-0 left-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
      >
        {/* Close Button (Mobile) */}
        <div className="md:hidden flex justify-end p-2">
          <button onClick={() => setSidebarOpen(false)}>
            <RxCross2 size={20} className="text-red-500" />
          </button>
        </div>

        {/* Logo */}
        <div className="flex items-center justify-center mb-6  mr-5">
          <div className=" h-28 ">
            <img
           /*  src='\assets\AZERO - WHITE.png' */
              src= "/assets/AZERO - WHITE.png"
              alt="Logo"
              className="w-full h-full rounded-full object-contain"
            />
          </div>
          {/* <div className="w-20">
            <img src="/assets/azero.jpeg" className="w-full object-cover" />
          </div> */}
        </div>

        {/* Navigation */}
        <div className="px-4">
          {data.map((val, i) => (
            <div key={i} className=" mb-4">
              <NavLink
                to={val.path}
                className={({ isActive }) =>
                  `flex items-center px-3 py-2 rounded-md font-medium transition ${
                    isActive ? "bg-primary text-white" : "text-gray-700"
                  }`
                }
                onClick={() => setSidebarOpen(false)}
              >
                <span className="mr-2">{val.icon}</span>
                {val.name}
              </NavLink>
            </div>
          ))}
        </div>
      </aside>

      {/* Overlay for Mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      
      <div className="flex-1 flex flex-col">
       
       {/*  <Header logo={logo} setSidebarOpen={setSidebarOpen} /> */}

       
        {/* <main className="flex-1 overflow-y-auto pt-16 md:pt-0 p-4 ">
         
        </main> */}
         <Outlet />

        {/* Mobile Bottom Navigation */}
        <div className="fixed bottom-0 left-0 right-0 z-40 bg-white shadow border-t md:hidden flex justify-around items-center py-2 px-4">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `flex flex-col items-center text-sm ${
                isActive ? "text-primary font-semibold" : "text-gray-600"
              }`
            }
          >
            <HiHome size={22} />
            <span className="text-xs">டாஷ்போர்டு</span>
          </NavLink>

          <NavLink
            to="/booking"
            className={({ isActive }) =>
              `flex flex-col items-center text-sm ${
                isActive ? "text-primary font-semibold" : "text-gray-600"
              }`
            }
          >
            <HiCalendar size={22} />
            <span className="text-xs">முன்பதிவு</span>
          </NavLink>

          <NavLink
            to="/transaction"
            className={({ isActive }) =>
              `flex flex-col items-center text-sm ${
                isActive ? "text-primary font-semibold" : "text-gray-600"
              }`
            }
          >
            <SiCashapp size={22} />
            <span className="text-xs">பரிவர்த்தனை</span>
          </NavLink>

          <NavLink
            to="/config"
            className={({ isActive }) =>
              `flex flex-col items-center text-sm ${
                isActive ? "text-primary font-semibold" : "text-gray-600"
              }`
            }
          >
            <CiSettings size={22} />
            <span className="text-xs">கட்டமைப்பு</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Layout;
